module.exports = __webpack_public_path__ + "img/copy_n.09f55540.png";